import { compose } from '@reduxjs/toolkit';
import { connect } from 'react-redux';
import { fetchWasLiveAssets, fetchLiveEncoders, fetchLiveAssets } from 'store/live/actions';
import { withNewsroom } from 'components/NewsroomsList/with-newsroom';
import { get } from 'lodash';
import {
    getSplittedAssetsByStatus,
    getWasLiveAssetsList,
    getUserRunningLiveAssets,
    getIsFetchingFlag,
    getErrors,
    getCurrentAndUpcomingLiveAssets,
} from 'store/live/selectors';
import { isNewLivePageEnabled } from 'lib/flags';

import LiveScreen from './LiveScreen';
import LiveScreen2 from './LiveScreen2';

const Screen = isNewLivePageEnabled ? LiveScreen2 : LiveScreen;

export default compose(
    withNewsroom,
    connect(
        (state) => {
            const userEmail = get(state, 'auth.token.sub');

            return {
                isFetching: getIsFetchingFlag(state),
                ...getSplittedAssetsByStatus(state),
                ...getCurrentAndUpcomingLiveAssets(state),
                wasLiveAssets: getWasLiveAssetsList(state),
                personalLiveAssets: getUserRunningLiveAssets(state, userEmail),
                ...getErrors(state),
            };
        },

        {
            fetchLiveAssets,
            fetchWasLiveAssets,
            fetchLiveEncoders,
        }
    )
)(Screen);
